import { ApolloClient, InMemoryCache } from '@apollo/client';

export default {
    SESSION_TIMEOUT: 60 * 1000 * 1500,
    client: new ApolloClient({
        uri: "http://qbank-staging.amckey.com:4000/graphql",
        cache: new InMemoryCache()
    }),
    API: {
        LOOKUP: 'https://svc-stage-lookup.dacsee.io',
        BOOKING: 'https://svc-stage-booking.dacsee.io',
        PAYMENT: 'https://svc-stage-payment.dacsee.io',
    },
    recaptcha_id: '6Lf6eaUZAAAAAI76PauZBCXHoYnBXf4_vRWULXbc',
    company_id: '5e8f1921087434edeb4a0f2b'
}



// WEBPACK FOOTER //
// ./src/configs/app-stage.js